import { useEffect } from "react";

/**
 * Esc във формата „Нова резервация" (панелът в „Резервации", модалът в
 * „Таблица на резервациите"): затваря я (preventDefault — иначе минава и
 * глобалното „назад"), а в поле (телефон, име, бележка…) само маха фокуса —
 * затваряне по време на писане би изтрило въведеното (следващото отваряне
 * прави reset). Календарът „Друга дата…" хваща Esc преди това (capture).
 */
export const useEscapeBlurOrClose = (onClose: () => void) => {
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key !== "Escape" || event.defaultPrevented) return;
      event.preventDefault();
      const target = event.target;
      if (
        target instanceof HTMLElement &&
        (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable)
      ) {
        target.blur();
        return;
      }
      onClose();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [onClose]);
};
